export const blockIconsPhotoandimageRotateRightNew = (
	<span className='material-symbols-outlined'>rotate_right</span>
);
